module.exports = __webpack_public_path__ + "static/media/sb-text-logo-white.36f63327.svg";